// extracted by mini-css-extract-plugin
module.exports = {"paymentItem":"FP","paymentItemContainer":"GP","paymentListContainer":"HP","titleWhenBackBtn":"IP"};